import Utils from "../utils/Utils";
const BlomBanckController = {
  authorize: ({ Authorization, request }) => {
    return Utils.controller(
      "api/blomPayment/v1/authorize",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  authorizeSavedCard: ({ Authorization, request }) => {
    return Utils.controller(
      "api/blomPayment/v1/authorizeSavedCard",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  captureContext: ({ Authorization, request }) => {
    return Utils.controller(
      "api/blomPayment/v1/captureContext",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
};

export default BlomBanckController;
